var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{staticClass:"app-main",class:_vm.appMainClass},[_c('Navbar'),_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view',{ref:"routeView",staticClass:"main-page",class:_vm.padClass})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }